module.exports = __webpack_public_path__ + "img/MovieVoteLogo.718e15c4.png";